import { EProductTourTargets } from '@constants';

import { Header } from './Header';
import { Wrapper } from './LiveClassesWidget.styles';

import { UpcomingEvents } from '@/components/UpcomingEvents';

export const LiveClassesWidget: React.FC = () => {
  return (
    <Wrapper id={EProductTourTargets.LIVE_CLASSES_WIDGET}>
      <Header />
      <UpcomingEvents />
    </Wrapper>
  );
};
